// SPDX-License-Identifier: AGPL-3.0-or-later

// Generated by tools/room_themes/build_manifest.mjs from validated room GLB files. Do not edit by hand.

export interface VoiceRoomThemeManifestEntry {
	readonly file: string;
	readonly bytes: number;
	readonly seats: ReadonlyArray<string>;
	readonly watch_seats: ReadonlyArray<string>;
	readonly tables: ReadonlyArray<{readonly slot: string; readonly seats: 4}>;
	readonly stands: number;
}

export const VOICE_ROOM_THEME_MANIFEST = {
	'gece-lounge': {
		file: 'gece-lounge.ae099f34df4a.glb',
		bytes: 2186520,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_D_01',
			'seat_D_02',
			'seat_D_03',
			'seat_D_04',
			'seat_D_05',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T01_Y3', 'seat_T01_Y4'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 12,
	},
	kahvehane: {
		file: 'kahvehane.18f9031e923f.glb',
		bytes: 3002904,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T02_Y1', 'seat_T02_Y2', 'seat_T03_Y1', 'seat_T03_Y2'],
		tables: [
			{slot: 'T01', seats: 4},
			{slot: 'T02', seats: 4},
			{slot: 'T03', seats: 4},
		],
		stands: 12,
	},
	'mahalle-kahvesi': {
		file: 'mahalle-kahvesi.06eb3e04e807.glb',
		bytes: 2320380,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T02_Y1', 'seat_T02_Y2'],
		tables: [
			{slot: 'T01', seats: 4},
			{slot: 'T02', seats: 4},
		],
		stands: 12,
	},
	'mor-sehir': {
		file: 'mor-sehir.8f35a810c577.glb',
		bytes: 2143336,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_B_05',
			'seat_B_06',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T01_Y3', 'seat_T01_Y4'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 12,
	},
	'neon-salon': {
		file: 'neon-salon.9b25c7e40cfd.glb',
		bytes: 2170404,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_A_09',
			'seat_A_10',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_C_05',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T01_Y3', 'seat_T01_Y4'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 12,
	},
	'oyun-odasi': {
		file: 'oyun-odasi.900d8ccf36d7.glb',
		bytes: 3132868,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
		],
		watch_seats: [
			'seat_T01_Y1',
			'seat_T01_Y2',
			'seat_T01_Y3',
			'seat_T01_Y4',
			'seat_T02_Y1',
			'seat_T02_Y2',
			'seat_T02_Y3',
			'seat_T02_Y4',
		],
		tables: [
			{slot: 'T01', seats: 4},
			{slot: 'T02', seats: 4},
		],
		stands: 12,
	},
	'yonetim-ofisi': {
		file: 'yonetim-ofisi.0240ae7b7f21.glb',
		bytes: 2618748,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_B_05',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_C_05',
			'seat_C_06',
			'seat_C_07',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 12,
	},
} as const satisfies Record<string, VoiceRoomThemeManifestEntry>;
